<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />

    <title>Document</title>
  </head>
  <body>
    <app-modal-neuropsychologie></app-modal-neuropsychologie>
    <app-modal-psychologie-clinique></app-modal-psychologie-clinique>
    <br />
    <div class="container" id="container-global">
      <div class="row">
        <div class="col-sm-0 col-md-0 col-lg-1 col-xl-2 center-image"></div>
        <div class="col-sm-6 col-md-6 col-lg-5 col-xl-4 center-image">
          <img
            class="rubrique-1 rubrique"
            src="/assets/images/accueil/psychologie-clinique-sinepsy-accueil.png"
            alt="1"
            data-micron="fade"
            max-width="100%"
            height="auto"
            data-bs-toggle="modal"
            data-bs-target="#modalPsychologieClinique"
          />
          <h2
            data-bs-toggle="modal"
            data-bs-target="#modalPsychologieClinique"
            class="title-accueil-flash"
          >
            Psychologie clinique
          </h2>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-5 col-xl-4 center-image">
          <img
            class="rubrique-2 rubrique"
            src="/assets/images/accueil/neuropsychologie-sinepsy-accueil.png"
            alt="1"
            data-micron="fade"
            max-width="100%"
            height="auto"
            data-bs-toggle="modal"
            data-bs-target="#modalNeuropsychologie"
          />
          <h2
            data-bs-toggle="modal"
            data-bs-target="#modalNeuropsychologie"
            class="title-accueil-flash"
          >
            Neuropsychologie
          </h2>
        </div>
        <div class="col-sm-0 col-md-0 col-lg-1 col-xl-2 center-image"></div>
      </div>
      <br /><br />
      <div class="container">
        <div class="row">
          <div class="col-md-2 bordure-gauche"></div>
          <div class="col-md-10">
            <h3>Votre psychologue à Saint Nazaire</h3>
            <p id="paragraphe-1" class="paragraphe">
              Chez SINEPSY, nous nous engageons à offrir des services de
              psychologie clinique et de neuropsychologie qui répondent à vos
              besoins. Faites le premier pas en choisissant notre expertise.
            </p>

            <h4>Service de Psychologie Clinique:</h4>

            <p>
              Notre cabinet offre des services de psychologie clinique de
              premier plan, mettant en avant un suivi psychothérapeutique fondé
              sur les approches reconnues de la thérapie comportementale et
              cognitive, ainsi que la thérapie ACT (Thérapie d'Acceptation et
              d'Engagement). Nous sommes conscients de l'importance cruciale de
              cibler les aspects comportementaux et cognitifs pour catalyser un
              changement valorisant dans votre vie.
            </p>

            <h4>Comment pouvons nous vous aider ?</h4>

            <p>
              Que vous traversiez un moment de stress, d'anxiété, des solutions
              pour des troubles de l'humeur, des conseils sur le plan
              relationnel ou un renforcement de l'estime et de la confiance en
              soi, notre équipe dévouée est prête à vous accompagner. Découvrez
              comment nos services de psychologie clinique peuvent vous aider à
              atteindre un équilibre mental durable.
            </p>

            <h4>Service de Neuropsychologie:</h4>

            <p>
              Notre service est spécialisé en neuropsychologie, offrant des
              bilans cognitifs approfondis destinés à évaluer les fonctions
              neuropsychologiques chez les enfants (à partir de 6 ans),
              adolescents et adultes. Nous accordons une importance particulière
              à la compréhension approfondie du fonctionnement de votre cerveau,
              sa relation avec votre fonctionnement comportemental et le lien
              avec les troubles émotionnels.
            </p>

            <h4>Exploration approfondie des domaines d'évaluation:</h4>

            <p>
              Nos experts en neuropsychologie se concentrent sur des domaines
              clés tels que la mémoire et l'apprentissage, l'attention et la
              concentration, les fonctions exécutives ainsi que le développement
              cognitif chez les enfants à partir de 6 ans. Chacune des
              évaluations nous permet de détecter et diagnostiquer des troubles
              neuropsychologiques ainsi que comprendre leur impact dans la vie
              quotidienne. Cette approche précise et ciblée nous sert de
              fondement à la personnalisation de la prise en charge rééducative,
              visant à maximiser les bénéfices pour chaque individu.
            </p>

            <h4>
              Contactez nous aujourd'hui pour planifier votre consultation.
              Votre bien-être mental est notre priorité.
            </h4>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
